import { List, Edit, PDFView, View, Create, CRCreate, CROutCreate } from "../Components/index.js";

export default [
    {
        path: "/letter/incoming",
        component: List,
        name: "letter.incoming",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/letter/incoming/:id/pdf-view",
        component: PDFView,
        name: "letter.incoming.pdf-view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/letter/incoming/:id/edit",
        component: Edit,
        name: "letter.incoming.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/letter/incoming/:id/view",
        component: View,
        name: "letter.incoming.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/letter/incoming/create",
        component: Create,
        name: "letter.incoming.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/letter/incoming/cr-create",
        component: CRCreate,
        name: "letter.incoming.cr.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/letter/outgoing/cr-create",
        component: CROutCreate,
        name: "letter.outgoing.cr.create",
        meta: {
            requiresAuth: true,
        },
    },
];
